import { render, staticRenderFns } from "./BookCarouselPopUp.vue?vue&type=template&id=1f92fa31&scoped=true&"
import script from "./BookCarouselPopUp.vue?vue&type=script&lang=js&"
export * from "./BookCarouselPopUp.vue?vue&type=script&lang=js&"
import style0 from "./BookCarouselPopUp.vue?vue&type=style&index=0&id=1f92fa31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f92fa31",
  null
  
)

export default component.exports